import * as tslib_1 from "tslib";
import { utils } from "@cloudpivot/common";
import { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE, IS_WECHAT, IS_WECHAT_PC_MAC, IS_WECHAT_PC_WINDOW, IS_WECHAT_DEVTOOL, } from "./is-platform";
import { BrowserService } from "./platform-service";
// import { DingTalkService } from './dingtalk/dingtalk-service';
import { Base64 } from "js-base64";
function parseToken(token) {
    const useInfoBs = token.split(".")[1];
    const useInfo = JSON.parse(Base64.decode(useInfoBs));
    return useInfo;
}
export { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE, IS_WECHAT, IS_WECHAT_PC_MAC, IS_WECHAT_PC_WINDOW, IS_WECHAT_DEVTOOL, };
let service = new BrowserService();
export function start(client_id, scope) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let _service = null;
        let query = utils.parseQuery();
        let urls = window.location.pathname;
        let loginInfo;
        let p = null;
        if (IS_DEBUG) {
        }
        else {
            // 解析href中token参数并存储到localStorage
            let regToken = new RegExp('[?&]T=(.+)(?=.*)');
            let regMatch = window.location.href.match(regToken);
            if (regMatch) {
                let token = regMatch[1];
                localStorage.setItem("token", token);
                // 这里是为了让utils.copyURL正常执行
                query.T = token;
            }
            if (IS_DINGTALK) {
                const dingtalk = yield import(
                /* webpackChunkName: "dingtalk" */ "./dingtalk");
                p = dingtalk.init(client_id, scope, query);
                _service = new dingtalk.DingTalkService();
            }
            if (IS_WECHAT && !IS_WECHAT_DEVTOOL) {
                // 企业微信统一配置pc端地址，在此判断是否跳转至移动端
                if (IS_WECHAT_PC_MAC || IS_WECHAT_PC_WINDOW) {
                    const wechat = yield import(
                    /* webpackChunkName: "dingtalk" */ "./wechat");
                    p = wechat.init(client_id, scope, query);
                    _service = new wechat.WechatService();
                }
                else {
                    if (window.location.href.indexOf("mobile") <= -1) {
                        const { origin, search } = window.location;
                        const url = `${origin}/mobile${search}`;
                        window.location.href = url;
                        return;
                    }
                    else {
                        const wechat = yield import(
                        /* webpackChunkName: "dingtalk" */ "./wechat");
                        p = wechat.init(client_id, scope, query);
                        _service = new wechat.WechatService();
                    }
                }
            }
        }
        if (_service) {
            service = _service;
        }
        if (p) {
            const res = yield p;
            if (res) {
                const { access_token, userinfo, refresh_token, expiration } = res;
                loginInfo = res;
                const info = parseToken(access_token);
                if (info) {
                    const user = userinfo;
                    user.isAppAdmin = info.isAppAdmin;
                    user.isAdmin = info.isAdmin;
                }
                sessionStorage.setItem("user", JSON.stringify(userinfo));
                localStorage.setItem("token", access_token);
                localStorage.setItem("refresh_token", JSON.stringify(refresh_token));
                localStorage.setItem("expireTime", `${expiration}`);
            }
        }
        else {
            utils.copyURL(query, 'portal');
        }
        return {
            query,
            loginInfo,
        };
    });
}
export { service };
